import { DefaultClass } from '../classes/DefaultClass.js';
import Filter from '../classes/Filter.js';
import { utils } from '../utils/index.js';
import { Calendar } from '../classes/Calendar.js';

/**
 *  Класс для страницы афишы
 * @extends DefaultClass
 */

export default class Index extends DefaultClass {
  constructor() {
    super();
    this.$items = $('#js-event-items');
  }

  init() {
    utils.toTop(this.$items);
    this.getLanguages().then(() => {
      const filter = new Filter();
      const calendar = new Calendar();
      filter.setActionMore();
      calendar.init();
    });
  }
}

const index = new Index();
index.init();
